import cuid from "cuid";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const id = useMemo(() => cuid(), []);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.TRACERS.LIST.path);
  const [addTracer] = useMutation(graphql.mutations.CREATE_TRACER, {
    refetchQueries: [
      {
        query: graphql.queries.TRACERS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.TRACERS.LIST.path);
    },
    onError: () => {},
  });
  const onSubmit = (_) => {
    const { name, source, destination, type, isExternal } = _;
    return addTracer({
      variables: {
        data: {
          id,
          destination,
          name,
          type,
          source: { id: source },
          isExternal,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} id={id} cancel={cancel} />;
};

export default Create;
